export const projectsEndpointIds = {
    GET_PROJECT_ADMIN: 'GET_PROJECT_ADMIN',
};
